<template>
  <div class="product-item-summary">
    <router-link
      :to="{
        name: 'ProductType',
        params: {
          name: name,
          type: 'feature',
        },
      }"
    >
      <img v-lazy="imagePath" />
    </router-link>
    <div class="summary-appeal">{{ appeal }}</div>
    <div class="summary-detail">{{ detail }}</div>
    <div class="summary-footer">
      <router-link
        v-for="(button, index) in buttons"
        :key="index"
        v-bind:to="{
          name: 'ProductType',
          params: {
            name: name,
            type: button.type,
          },
        }"
      >
        {{ button.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'imagePath', 'appeal', 'detail'],
  data() {
    return {
      buttons: [
        { name: '商品特徴', type: 'feature' },
        { name: '仕 様', type: 'spec' },
        { name: '価 格', type: 'price' },
        { name: 'カタログ', type: 'catalogue' },
      ],
    }
  },
}
</script>

<style>
.product-item-summary img {
  width: 100%;
  height: auto;
}

.summary-title {
  font-weight: bold;
}

.summary-appeal {
  font-weight: bold;
}

.summary-detail {
  font-size: 14px;
}

.summary-footer {
  display: flex;
  justify-content: space-between;
}

.summary-footer a {
  font-size: 12px;
  font-weight: bold;

  display: inline-block;

  width: 23%;
  padding: 10px 0;

  text-align: center;
  text-decoration: none;

  border: 1px solid;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ProductItemSummary.vue